export enum CONFIGURATIONS_COMPONENTS {
  ACCOUNT_RATIO_PER_CONTROLLER = "Account Ratio Per Controller",
  BANK_STMT_CONFIG = "Bank Stmt Config",
  SUSPENSE_ACCOUNT_MAPPING = "Suspense Account Mapping",
  BULK_BAD_DEBT_CONFIGURATION = "Bulk Bad Debt Configuration",
  CALL_ESCALATION_CONFIGURATION = "Call Escalation Configuration",
  CALL_OUTCOME_WRAP_UP = "Call Outcome & Wrap Up",
  INCENTIVE_CONFIGURATION = "Incentive Configuration",
  CREDIT_CONTROL_LETTER = "Credit Control - Letter",
  CESSION_LETTERS = "Cession Letters",
  CREDIT_CONTROL_MAPPING = "Credit Control Mapping",
  CREDIT_CONTROLLER_CUT_OFF_DATES = "Credit Controller Cut Off Dates",
  CRITERIA_FOR_REASSIGNING_ACCOUNTS = "Criteria For Reassigning Accounts",
  FINAL_DEMAND_REJECTION_REASON = "Final Demand Rejection Reason",
  THIRD_PARTY_EXCLUSIONS = "Third Party Exclusions",
  PRODUCTIVITY_TARGET = "Productivity Target",
  PRODUCTIVITY_TARGET_EXCLUSION = "Productivity Target Exclusion",
  REFUSE_TO_PAY_CONFIG = "Refuse To Pay Config",
  SMALL_BALANCE_CONFIGURATION = "Small Balance Configuration",
  SMALL_BALANCE_EXCLUSION = "Small Balance Exclusion",
  SMS_BANK_MAPPING = "SMS Bank Mapping",
  VENDOR_REGISTRATION_DOC_TYPE = "Vendor Registration Doc Type",
  CAMPAIGN_FREQUENCY = 'Campaign Frequency Type',
  CPA_NOTICES = 'CPA 80-40 Notices'
}
enum CONFIGURATION_COMPONENT {
  AUTOMATED_REQUISITION_CONFIGURATION = "Automated Requisition Configuration",
  BILLING = "Billing",
  BANK_CONFIGURATION = "Bank Configuration",
  STOCKID_CONFIGURATION = "StockId Configuration",
  TRANSACTIONS = "Transactions",
  PRICE_INCREASE_RUN_DATE_CONFIG = "Price Increase Run Date Config",
  PRICE_INCREASE_CONFIGURATION = "Price Increase Configuration",
  LICENSE_BILL_MODE = "License Bill Mode",
  STATEMENT_FEE = "Statement Fee",
  BILLING_NOTIFICATION = "Billing Notification",
  BILLING_CONFIGURATION = "Billing Configuration",
  FINANCIAL_YEAR_CONFIGURATION = "Financial Year Configuration",
  FINANCIAL_PERIOD_CONFIGURATION = "Financial Period Configuration",
  BILL_RUN_DATE_CONFIGURATION = "Bill Run Date Configuration",
  TEST_RUN_CONFIGURATION = "Test Run Configuration",
  MERCANTILE_USER_CODE = "Mercantile User Code",
  PAYMENT_FREQUENCY_CONFIGURATION = "Payment Frequency Configuration",
  ADMIN_FEE = "Admin Fee",
  COMMS_TYPE_CONFIGURATION = "Comms Type Configuration",
  LICENSE_TYPE_CONFIGURATION = "License Type Configuration",
  ERB_BILL_RUN_DATE_CONFIGURATION = "ERB Bill Run Date Configuration",
  SALES = "Sales",
  LEAD = "Lead",
  SERVICES = "Services",
  SAME_DAY_RUN_CUT_OFF_TIME = "Same Day Run Cut Off Time",
  STOCK_MAINTENANCE_CONFIGURATION = "Stock Maintenance Configuration",
  SYSTEM_TYPE = "System Type",
  COMPONENT_GROUP = "Component Group",
  COMPONENT = "Component",
  BRAND = "Brand",
  SYSTEM_TYPE_SUB_CATEGORY = "System Type Sub Category",
  OBSOLETE = "Obsolete",
  BOUNDARY_MANAGEMENT = "Boundary Management",
  AREA_SETUP_PARAMETERS = "Area Setup Parameters",
  OPERATIONS = "Operations",
  BOUNDARY_DOA_CONFIGURATION = "Boundary DOA Configuration",
  LEAVE_MANAGEMENT_REQUEST = "Leave Management Request",
  PAYMENT_CONFIGURATION = "Payment Configuration",
  BANK_ACCOUNT_TYPE = "Bank Account Type",
  DEBIT_ORDER_RUN_CODE = "Debit Order Run Code",
  COMPANY_BANKING_MAINTANENCE = "Company Banking Maintanence",
  TAX = "Tax",
  LEAVE_MANAGEMENT_APPROVAL = "Leave Management Approval",
  LSS = "LSS",
  SCHEME_TYPES = "Scheme Types",
  RESOURCES = "Resources",
  ESCALATION_CONFIG = "Escalation Config",
  WORKFLOW_CONFIG = "Workflow Config",
  DOA_CONFIG = "DOA Config",
  CUSTOMER_MANAGEMENT = "Customer Management",
  CUSTOMER_TICKETS = "Customer Tickets",
  CUSTOMER_TICKET_SLA = "Customer Ticket SLA",
  DATA_MAINTENANCE = "Data Maintenance",
  REPOSITORY = "Repository",
  MANUAL_REPOSITORY = "Manual Repository",
  REPOSITORY_ACCESS_PERMISSION = "Repository Access Permission",
  CALENDAR_EVENT = "Calendar Event",
  BALANCE_OF_CONTRACT_CHARGE = "Balance Of Contract Charge",
  YEARLY_TERMINATION_FEE = "Early Termination Fee",

  OUT_OF_OFFICE = "Out Of Office",
  TOLERANCE_CONFIGURATION = "Tolerance Configuration",
  ITEMS = 'Items',
  QUOTATION = 'Quotation',
  SELLER_MANAGEMENT = 'Seller Management',
  CLASSIFICATION = 'Classification',
  ANNUAL_NETWORK_ADMIN_FEE_PRO_RATA = 'Annual Network Admin Fee - Pro Rata',
  FUEL_INCRESS_LETTER_CONFIG = 'Fuel Price Increase Letter Config',
  CREDITCARD_EXPIRY_DATE_NOTIFICATION = 'Credit Card Expiry Date Notification',
  PAY_AT_BDI = 'Pay@ BDI Code Config',
  PURCHASE_OF_ALARAM_SYSTEM_CONFIG = 'Purchase Of Alarm System Config',
  REQUISITION_INITIATOR_CONFIGURATION = 'Requisition Initiator Configuration',
  CONTACT_CENTRE = 'Contact Centre',
  CAMPAIGN_TYPE = 'Campaign Type Config',
  OUT_OF_OFFICE_REASON = 'Out Of Office Reasons',
  CANCELLATIONS = 'Cancellations',
  CLASSIFICATIONS = 'Classifications',
  DEALER_CLASSIFICATION_MAPPING = 'Dealer Classification Mapping',
  FIRST_SIGNAL_CONFIGURATION = 'First Signal Configuration',
  MASTER_ESCALATION_CONFIG = "Master Escalation Configuration",
  RAIO_LOST_MAPPING = 'Radio Lost Mapping',
  VEHICLE_CONFIGURATION = 'Vehicle Configuration',
  CALL_REASON = 'Call Reason'
}

export { CONFIGURATION_COMPONENT }

